<template>
  <div id="Haomaluzhu">
    <div class="tr-header">
      <p class="title">总和路珠</p>
      <div class="dayHandles">
        <DatePick @onchange="onchangeDate"></DatePick>
      </div>
    </div>

    <div class="tr-table-container">
      <Road v-for="(it,i) in dataSource" :data="it" :date="date" :key="i"></Road>
      <div v-html="tips[betType]"></div>
    </div>
  </div>
</template>

<script>
import DatePick from "../components/DatePick";
import dayjs from "dayjs";
import statistic from "../../../helpers/statistic";
import Road from "./Road";
import format from "../../../helpers/format.js";
import tips from "./helpers/tips";
function setBall(start, len) {
  let res = [];
  for (let i = start; i <= len; i++) {
    res.push({
      name: `号码${i}`,
      key: i
    });
  }
  return res;
}
const sscBalls = setBall(0, 9);
const ksBalls = setBall(1, 6);

export default {
  name: "Haomaluzhu",
  components: {
    DatePick,
    Road
  },
  data() {
    return {
      tips,
      selectDay: dayjs(new Date()).format("YYYY-MM-DD"),
      dataSource: [],
      date: "",
      balls: [],
      selectBalls: []
    };
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    },
    roadsData() {
      return statistic.getBallRoads(this.betType, this.dataSource);
    }
  },
  created() {
    // console.log("bet", this.betType);
    this.reset();
  },
  methods: {
    onchangeDate(date) {
      this.selectDay = dayjs(date).format("YYYY-MM-DD");
      this.getData();
    },
    reset() {
      if (this.betType == "ssc" || this.betType == "choose5") {
        this.balls = sscBalls;
        this.selectBalls = this.balls.map(x => x.key);
      }
      if (this.betType == "ks") {
        this.balls = ksBalls;
        this.selectBalls = this.balls.map(x => x.key);
      }
    },
    init() {
      this.getData();
    },
    async getData() {
      let res = await this.$http.post("/queryKcDateReport.do", {
        gameType: this.$route.params.gameType,
        date: this.selectDay
      });

      if (res.data.returnCode == "0000") {
        if (res.data.returnList[0]) {
          this.date = res.data.returnList[0].date;
        }
        var arr = format.formatJson(res.data.returnList);
        if (arr.length > 0) {
          var a = this.formatList(arr[0].ball_dewdrop_json.sum);
          // console.log("a", a);
          this.dataSource = a;
        } else {
          this.dataSource = [];
        }
      } else {
        this.$Message.error(res.data.returnMessage);
      }
    },
    formatList(obj) {
      var keys = Object.keys(obj);
      var arr = [];
      for (let i = 0; i < keys.length; i++) {
        var o = {};
        const e = keys[i];
        o[e] = obj[e];
        arr.push(o);
      }
      return arr;
    }
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>




// WEBPACK FOOTER //
// src/pages/Trend/Zongheluzhu/index.vue